// extracted by mini-css-extract-plugin
export var BlogArticles = "BlogArticles-module--BlogArticles--1yWin";
export var BlogArticles__article = "BlogArticles-module--BlogArticles__article--6a32F";
export var gatsbyImageWrapper = "BlogArticles-module--gatsby-image-wrapper--357Ws";